export const FAST_TRANSFER_MANAGER_STRINGS = {
  HEADING: 'Fast Transfer Manager',
  SUBHEADING: 'View and update fast transfer configuration at a country level',
  TABLE_HEADING: 'Fast Transfer Configuration Table',
  NO_CONFIG_FOUND: 'No Fast Transfer Configuration Found!',
  CONFIRM_UPDATE_TITLE: 'Confirm Update',
  CONFIRM_UPDATE_MESSAGE: 'Are you sure you want to update the Fast Transfer Configuration?',
  CONFIRM_NO_CHANGES: 'No rail changes detected.',
};
